import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UserService } from '@services/user.service';
import { ConfirmOtpComponent } from '../confirm-otp/confirm-otp.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AssessmentService } from '../../services/assessment.service';
import { NotificationService } from '@services/notification.service';
import { customValidationService } from 'src/app/shared/custom.validator';
import { AccountAdminRole } from '@configs/role.config';
import { WebErrorService } from '@services/webError.service';
@Component({
  selector: 'app-assign-assessment',
  templateUrl: './assign-assessment.component.html',
  styleUrls: ['./assign-assessment.component.scss']
})
export class AssignAssessmentComponent implements OnInit {
  patientdetails: FormGroup;
  inValidPhone: boolean = false;
  selectedOption: any = '1'
  selecteddoctorName: any;
  selectedcenter: any;
  languageData = [];
  doctorNameData = [];
  centerData = [];
  selectedLang: any;
  ageYears: any;
  ageMonth: any;
  // search dropdown
  searchYearOptions = [];
  selected: any;
  filteredYearList: any[] = [];
  searchMonthOptions = [];
  filteredMonthList: any[] = [];
  years: any;
  months: any;
  isEdit: boolean = false;
  assessmentStart: boolean = false;
  assignedRole: any;
  accountAdmin = AccountAdminRole.accountAdmin;
  collectionId: any;
  countryDropdownList: any;
  countryDropdownOptions = [];
  selectedcountryy: any;
  selectedcountry: any;
  filteredDoctorList: any[] = [];
  doctorListOptions: any[] = [];
  constructor(public fb: FormBuilder,
    private userService: UserService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<AssignAssessmentComponent>,
    public cd: ChangeDetectorRef,
    public AssessmentService: AssessmentService,
    private notificationService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private webErrorService: WebErrorService,) {
    this.collectionId = JSON.parse(sessionStorage.getItem('defaultcollectionid'));
    this.assignedRole = JSON.parse(sessionStorage.getItem('currentUser') || '{}').userRolesCollections[0].rolesAssigned;

    this.patientdetails = new FormGroup({
      patientid: new FormControl(0),
      center: new FormControl(),
      doctorName: new FormControl(null),
      firstName: new FormControl(null,
        [Validators.required,
        Validators.minLength(2),
        Validators.maxLength(30),
        Validators.pattern(/^[ a-zA-Z.-]+([a-zA-Z.-. ])*$/)
        ]),
      lastName: new FormControl(null, [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(30),
        Validators.pattern(/^[ a-zA-Z.-]+([a-zA-Z.-. ])*$/)
      ]),
      countryCode: new FormControl(null),
      phone: new FormControl(null, [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(24),
        Validators.pattern(/^(?:\+?(\d{0,3}))?[- \(]*(\d{1,9})[-. \/)]*(\d{1,9})[-. \/]*(\d{1,9})*[-. \/]*(\d{1,9})(?: *x(\d))?$/)
      ]),
      emailId: new FormControl(null,
        [Validators.minLength(7),
        Validators.maxLength(124),
        Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}')

        ]),
      ageYears: new FormControl(null, [Validators.required]),
      ageMonth: new FormControl(null, [Validators.required]),
      gender: new FormControl(1, [Validators.required]),
      weight: new FormControl('', [Validators.required]),
      height: new FormControl('', [
        Validators.required,
        Validators.minLength(1),
        // Validators.maxLength(300),
        // Validators.pattern('^(?:[1-9]|[1-9][0-9]|[1-2][0-9]{2}|300)$'),
      ]),
      langid: new FormControl(null, [Validators.required]),
      reasonofvisit: new FormControl('', [
        Validators.minLength(1),
        Validators.maxLength(1000),
      ]),
    });

    if (this.assignedRole == this.accountAdmin) {
      const center = <FormControl>this.patientdetails.get('center');
      center.setValidators([Validators.required]);
      center.updateValueAndValidity();

      const doctorName = <FormControl>this.patientdetails.get('doctorName');
      doctorName.setValidators([Validators.required]);
      doctorName.updateValueAndValidity();
    }

    const langId = localStorage.getItem("langId");
    if (langId != undefined || null || '') {
      this.selectedLang = langId;
    }

    this.userService.getLanguage().subscribe(lang => { this.languageData = lang.items; });
    this.getYears();
    this.getMonths();

    this.data.countryCodes.forEach(d => {
      d.displayName = d.name + '-' + d.dial_code
    })
    this.countryDropdownOptions = this.data.countryCodes;
    this.countryDropdownList = this.countryDropdownOptions;

    const domain = window.location.hostname;

    const subdomain = domain.split('.')[0];

    let countryCodeMap: any = {
      drr: '+91',
      qa: '+91',
      svaas: '+91',
      'svaas-brazil': '+55',
      localhost: '+91',
      br: '+55',
      col: '+57'
    };

    this.selectedcountry = countryCodeMap[subdomain] || '+91';

    this.patientdetails.controls.countryCode.setValue(this.selectedcountry);

    // this.selectedcountry = domain.split('.')[0] == 'drr' || domain.split('.')[0] == 'qa' || domain.split('.')[0] == 'svaas'
    // || domain.split('.')[0] == 'localhost' ? '+91' : domain.split('.')[0] == 'br' ? '55' : domain.split('.')[0] == 'col' ? '+57' : '';
    // this.patientdetails.controls.countryCode.setValue(this.selectedcountry)

    // const timeZoneOffset = new Date().getTimezoneOffset();
    // console.log(moment.tz.zone('GMT+0530'))
    // console.log(Intl.DateTimeFormat().resolvedOptions().timeZone)

    this.AssessmentService.getCenterList(this.collectionId).subscribe(data => {
      this.centerData = data.data;
    });

    this.AssessmentService.getDoctors(this.collectionId).subscribe(data => {
      this.doctorNameData = data.data;
    });
  }

  onSelectCenter(event) {
    this.doctorListOptions = [];
    this.filteredDoctorList = [];
    this.doctorNameData.filter(d => {
      if(d.centerName == event.target.value) {
        this.filteredDoctorList.push(d);
      }
    })
    this.doctorListOptions = this.filteredDoctorList;
  }

  ngOnInit(): void {
    if (this.data.row) {
      this.isEdit = true;
      this.AssessmentService.getPatientDetails(this.data.row.patientid).subscribe(patient => {
        this.selectedcountry = patient?.data?.countryCode
        this.patientdetails.patchValue({
          patientid: patient?.data?.patientid,
          firstName: patient?.data?.firstname,
          lastName: patient?.data?.lastname,
          countryCode: patient?.data?.countryCode,
          phone: patient?.data?.phone,
          emailId: patient?.data?.emailid,
          ageYears: patient?.data?.ageyears.toString(),
          ageMonth: patient?.data?.agemonth.toString(),
          gender: patient?.data?.gender,
          weight: patient?.data?.weight,
          height: patient?.data?.height,
          langid: patient?.data?.langid,
          reasonofvisit: patient?.data?.reasonofvisit,
          center: patient?.data?.center,
          doctorName: patient?.data?.doctorName
        })

        if (this.data.row.assessmentStatusId == 3 || this.data.row.assessmentStatusId == 2) {
          this.patientdetails.controls.firstName.disable();
          this.patientdetails.controls.lastName.disable();
          this.patientdetails.controls.countryCode.disable();
          this.patientdetails.controls.phone.disable();
          this.patientdetails.controls.emailId.disable();
          this.patientdetails.controls.ageYears.disable();
          this.patientdetails.controls.ageMonth.disable();
          this.patientdetails.controls.gender.disable();
          this.patientdetails.controls.weight.disable();
          this.patientdetails.controls.height.disable();
          this.patientdetails.controls.langid.disable();
          this.patientdetails.controls.reasonofvisit.disable();
          this.patientdetails.controls.center.disable();
          this.patientdetails.controls.doctorName.disable();
        }
      });
    }
  }

  get f() {
    return this.patientdetails.controls;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  getYears() {
    // Dropdown Search filter
    let numbers = [];
    for (let i = 0; i <= 150; i++) {
      numbers[i] = i.toString();
    }
    this.years = numbers;
    this.searchYearOptions = numbers;
    this.filteredYearList = this.searchYearOptions.slice();
  }

  getMonths() {
    // Dropdown Search filter
    let numbers = [];
    for (let i = 0; i <= 11; i++) {
      numbers[i] = i.toString();
    }
    this.months = numbers;
    this.searchMonthOptions = numbers;
    this.filteredMonthList = this.searchMonthOptions.slice();
  }

  onSelectAge() {
    let ageYears = this.patientdetails.controls.ageYears.value;
    let ageMonth = this.patientdetails.controls.ageMonth.value;

    if (ageYears == 0 && ageMonth == 0) {
      this.assessmentStart = true;
    } else {
      this.assessmentStart = false;
    }
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    console.log(k);
    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 ||(k >= 48 && k <= 57) || k == 46);
  }

  validateHeight(event) {
    const inputElement = event.target;
    const value = inputElement.value;

    const regex = /^(?:[1-9]|[1-9][0-9]|[1-9][0-9][0-9]|900)$/;
    if (!regex.test(value)) {
      inputElement.value = value.slice(0, -1);
      this.patientdetails.controls.height.setValue(inputElement.value)
    }
  }
  iswightInvalid: any;
  validateInput(event) {
    const inputElement = event.target;
    const value = inputElement.value;

    const regex = /^\d{0,3}(\.\d{0,2})?$/;
    const inputVal = inputElement.value.split('.')
    const beforeDecimal = inputVal[0]
    const afterDecimal = inputVal[1]

    if (value == '') {
      this.patientdetails.controls.weight.setValue('')
      this.iswightInvalid = false;
    }
    if (!regex.test(value)) {
      inputElement.value = value.slice(0, -1);
      this.iswightInvalid = true;
      // this.patientdetails.controls.weight.setValue(parseFloat(inputElement.value))
      if(beforeDecimal.length == 4 && (afterDecimal != undefined && afterDecimal.length > 1)) {
        inputElement.value = ''
        this.patientdetails.controls.weight.setValue(0)
      }
    }
  }

  onClickOutside(event: any) {
    if(event) {
      this.inValidPhone = true;
    } else {
      this.inValidPhone = false;
    }
  }

  onKeydown(event: KeyboardEvent) {
    if (event.key === ' ' && !this.patientdetails.value.phone.length)
      event.preventDefault();
  }

  changeField(event: KeyboardEvent) {
    if (event.key === ' ' && !this.patientdetails.value.emailId.length)
      event.preventDefault();
  }

  onSubmit() {
    this.patientdetails.value.countryCode = this.selectedcountry;
    if (!this.isEdit) {
      this.AssessmentService.submitPatientDetails(this.patientdetails.value, this.collectionId).subscribe(data => {
        if (data.success) {
          this.notificationService.success(data.message);
          this.dialogRef.close(data.success);
          const dialogSubscription = this.dialog.open(ConfirmOtpComponent, { minWidth: '450px', data: data.data}).afterClosed().subscribe((res) => {
            this.AssessmentService.confirmOtp.next(true);
          });
        }
      }, (error: any) => {
        this.webErrorService.handleAPIErrors(error, null, true, 'warn');
      });
    } else {
      this.AssessmentService.edittPatientDetails(this.patientdetails.value, this.collectionId).subscribe(data => {
        if (data.success) {
          this.notificationService.success(data.message);
          this.dialogRef.close(data.success);
        }
      }, (error: any) => {
        this.webErrorService.handleAPIErrors(error, null, true, 'warn');
      });
    }

  }
}
